module.exports = __webpack_public_path__ + "img/banner.9800b7fb.png";